













import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { StepKeys } from '../../variables/ACF_Key'
import Wizard from '../Wizard.vue'
import Thumbs from '../../components/Thumbs.vue'
import Title from '../../components/Title.vue'
import Loader from '../../components/Loader.vue'
import Ctas from '../../components/Ctas.vue'
@Component({
  components: {
    Thumbs,
    Title,
    Wizard,
    Loader,
    Ctas
  },
  computed: {
    ...mapState({
      responseACF: 'acfApi'
    })
  }
})
export default class Etape1 extends Vue {
    // Datas de la vue :
    public ready = false
    public readyData = false
    // Data a transmettre au titre :
    public titleMain !: string
    // Datas a transmettre au thumb :
    public item1 !: string
    public item2 !: string
    public item3 !: string
    public item4 !: string
    // Vue actuelle
    public step = 1

    //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
    public responseACF!: Record<string, string>

    sortACFForThisView (): void{
      // Appel la class permettant de lire le trie du JSON (API WP)
      const thumbInfo = new StepKeys(this.responseACF)
      if (thumbInfo) {
        // Ajouter la clef ACF des items de la vue
        /***
         * INFO si dessous à modifier celon le projet :
         */
        this.item1 = thumbInfo.getValue('you_are_grp_1')
        this.item2 = thumbInfo.getValue('you_are_grp_2')
        this.item3 = thumbInfo.getValue('you_are_grp_3')
        this.item4 = ''
        /***
         * Titre de la vue :
         */
        this.titleMain = thumbInfo.getSimpleValue('you_are_title')
        // Petite verification en + car sur cette vue on charge tout les ACFs ( ça peu être + long )
        if (this.titleMain && this.item1 && this.item2 && this.item3) {
          this.readyData = true
        }
      }
    }

    appendContentPage (value: boolean): boolean {
      if (value === true) {
        this.ready = true
      }
      return this.ready
    }

    /***
     * VUE STATE =>
     */
    mounted (): void {
      const haveDatas = this.$store.getters.getValueOfACF
      //* ** SI la vue n'a pas déjà été visitée , on appel l'API WP */
      if (haveDatas && Object.keys(haveDatas).length === 0 && Object.getPrototypeOf(haveDatas) === Object.prototype) {
        this.$store.dispatch('LoadAllACF').then((data) => {
          if (data != null) {
            this.sortACFForThisView()
          }
        })
      } else {
        //* ** Sinon on transfert directement les données de vuex */
        this.responseACF = haveDatas
        this.sortACFForThisView()
        this.ready = true
      }
    }

}
